import { App } from 'vue'
import { Lazyload, Loading } from 'vant'
import 'vant/lib/index.css'

export const vantPlugins = {
  install: (app: App<Element>): void => {
    app.use(Lazyload, {
      lazyComponent: true
    })
    app.use(Loading)
  }
}
